import React from 'react'
import { t } from 'ttag'

import { CandidateManagementModal } from 'components/modals/CandidateManagementModal/CandidateManagementModal'
import { DeleteCandidateModal } from 'components/modals/DeleteCandidateModal/DeleteCandidateModal'
import { MoveCandidateModal } from 'components/modals/MoveCandidateModal/MoveCandidateModal'
import { TestsReportModal } from 'components/modals/TestsReportModal/TestsReportModal'
import { DeleteCandidateGroupModal } from 'components/modals/DeleteCandidateGroupModal/DeleteCandidateGroupModal'
import { ExportCandidateGroupModal } from 'components/modals/ExportCandidateGroupModal/ExportCandidateGroupModal'
import { MoveCandidateGroupModal } from 'components/modals/MoveCandidateGroupModal/MoveCandidateGroupModal'
import { ActionsDropdown } from 'components/shared/ActionsDropdown/ActionsDropdown'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { ResultsTable } from './common/ResultsTable/ResultsTable'
import { FilterDropdown } from 'components/shared/FilterDropdown/FilterDropdown'
import { getFiltersConfigs } from '../model'
import { useJobResultsTab } from './hooks'
import { PaneTitle } from '../PaneTitle/PaneTitle'
import styles from './Results.module.scss'
import { CompareButton } from '../CompareButton/CompareButton'

export const Results = ({
  activeTab,
  project,
  hasInterviewModule,
  isInterviewAvailable,
}) => {
  const { id, name, active } = project ?? {}

  const { state, handlers } = useJobResultsTab({ projectId: id })

  const {
    actions,
    candidate,
    count,
    search,
    filter,
    selectedCandidates,
    hasTwoCandidatesSelected,
    hasMoveCandidatesFeature,
    isCandidateManagementModalOpen,
    isDeleteCandidateModalOpen,
    isMoveCandidateModalOpen,
    isTestsReportModalOpen,
    isDeleteCandidateGroupModalOpen,
    isExportCandidateGroupModalOpen,
    isMoveCandidateGroupModalOpen,
  } = state
  const {
    getActions,
    handleFavorite,
    handleCandidateManagementModalClose,
    handleCandidateManagementModalConfirm,
    handleDeleteCandidateModalClose,
    handleDeleteCandidateModalConfirm,
    handleMoveCandidateModalClose,
    handleMoveCandidateModalConfirm,
    handleTestsReportModalClose,
    handleDeleteCandidateGroupModalClose,
    handleDeleteCandidateGroupModalConfirm,
    handleExportCandidateGroupModalClose,
    handleMoveCandidateGroupModalClose,
    handleMoveCandidateGroupModalConfirm,
    handleInterview,
    handleTestsReport,
    handleCompare,
    setFilter,
    setSearch,
  } = handlers

  return (
    <>
      <Pane.Header
        direction="column"
        subtitle={`${count} ${t`candidates`}`}
        title={<PaneTitle label={name} active={active} />}
      >
        <SearchWidget query={search} onChange={setSearch} />
        <FilterDropdown
          size="small"
          filter={filter}
          setFilter={setFilter}
          filtersConfig={getFiltersConfigs()}
        />
        <CompareButton
          isDisabled={!hasTwoCandidatesSelected}
          handleClick={handleCompare}
        />
        <ActionsDropdown
          anchorClassName={styles.button}
          size="small"
          isDisabled={!active}
          {...{ actions }}
        />
      </Pane.Header>
      <ResultsTable
        projectId={id}
        tab={activeTab}
        onInterview={handleInterview}
        onTestsReport={handleTestsReport}
        {...{
          search,
          filter,
          setFilter,
          getActions,
          hasInterviewModule,
          isInterviewAvailable,
          handleFavorite,
          active,
        }}
      />
      {hasMoveCandidatesFeature ? (
        <MoveCandidateGroupModal
          onCancel={handleMoveCandidateGroupModalClose}
          onClose={handleMoveCandidateGroupModalClose}
          onConfirm={handleMoveCandidateGroupModalConfirm}
          isOpen={isMoveCandidateGroupModalOpen}
        />
      ) : null}
      <ExportCandidateGroupModal
        onCancel={handleExportCandidateGroupModalClose}
        onClose={handleExportCandidateGroupModalClose}
        isOpen={isExportCandidateGroupModalOpen}
      />
      <DeleteCandidateGroupModal
        onCancel={handleDeleteCandidateGroupModalClose}
        onClose={handleDeleteCandidateGroupModalClose}
        onConfirm={handleDeleteCandidateGroupModalConfirm}
        isOpen={isDeleteCandidateGroupModalOpen}
      />
      {isTestsReportModalOpen ? (
        <TestsReportModal
          onCancel={handleTestsReportModalClose}
          onClose={handleTestsReportModalClose}
          isOpen={isTestsReportModalOpen}
          project={project}
          candidates={candidate ? [candidate] : selectedCandidates}
        />
      ) : null}
      <CandidateManagementModal
        onCancel={handleCandidateManagementModalClose}
        onClose={handleCandidateManagementModalClose}
        onConfirm={handleCandidateManagementModalConfirm}
        isOpen={isCandidateManagementModalOpen}
        {...{ candidate }}
      />
      {hasMoveCandidatesFeature ? (
        <MoveCandidateModal
          name={candidate?.name}
          onCancel={handleMoveCandidateModalClose}
          onClose={handleMoveCandidateModalClose}
          onConfirm={handleMoveCandidateModalConfirm}
          isOpen={isMoveCandidateModalOpen}
        />
      ) : null}
      <DeleteCandidateModal
        name={candidate?.name}
        onCancel={handleDeleteCandidateModalClose}
        onClose={handleDeleteCandidateModalClose}
        onConfirm={handleDeleteCandidateModalConfirm}
        isOpen={isDeleteCandidateModalOpen}
      />
    </>
  )
}
